import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * An incomplete facade for the browser performance API.
 */
var PerformanceFacade = /*#__PURE__*/function () {
  function PerformanceFacade(performance) {
    _classCallCheck(this, PerformanceFacade);
    this._performance = performance;
  }
  _createClass(PerformanceFacade, [{
    key: "isAvailable",
    get: function get() {
      return Boolean(this._performance);
    }
  }, {
    key: "now",
    value: function now() {
      return this._performance ? this._performance.now() : Date.now();
    }
  }, {
    key: "getEntriesByName",
    value: function getEntriesByName(name, type) {
      return this._performance ? this._performance.getEntriesByName(name, type) : [];
    }
  }, {
    key: "durationSince",
    value: function durationSince(time) {
      return Math.trunc(this.now() - time);
    }
  }]);
  return PerformanceFacade;
}();
export { PerformanceFacade };